import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoRootModule } from '../transloco/transloco-root.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';

import { StatisticsViewComponent } from './partials/statistics-view/statistics-view.component';
import { AcCompetenceStatisticsComponent } from './pages/ac-competence-statistics/ac-competence-statistics.component';
import { AcCompetenceOverviewChartComponent } from './partials/charts/ac-competence-overview-chart/ac-competence-overview-chart.component';
import { AcCompetenceDetailChartComponent } from './partials/charts/ac-competence-detail-chart/ac-competence-detail-chart.component';
import { AcCompetenceFilterComponent } from './partials/filters/ac-competence-filter/ac-competence-filter.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CardModule } from 'primeng/card';
import { SharedModule } from '../shared/shared.module';
import { AcRecommendationsChartComponent } from './partials/charts/ac-recommendations-chart/ac-recommendations-chart.component';


@NgModule({
  declarations: [
    StatisticsViewComponent,
    AcCompetenceStatisticsComponent,
    AcCompetenceOverviewChartComponent,
    AcCompetenceDetailChartComponent,
    AcCompetenceFilterComponent,
    AcRecommendationsChartComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    TranslocoRootModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    CardModule,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    ProgressSpinnerModule,
    DialogModule,
    DropdownModule,
    ToastModule,
    MessagesModule,
    MessageModule,
    TooltipModule,
    CalendarModule
  ],
  exports: [
    AcCompetenceOverviewChartComponent,
    AcCompetenceDetailChartComponent,
    AcCompetenceStatisticsComponent,
    StatisticsViewComponent
  ]
})
export class StatisticsModule { }
